
export default {
  name: 'Breadcrumbs',

  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
};
